import React from "react";

import { ReactComponent as PlusWhiteIcon } from "src/images/plus-white.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import NotFoundImg from "src/images/clickbait.svg";
import { EmptyTabContainer } from "./EmptyTabContainer/EmptyTabContainer";
import { EmptyTabContent } from "./EmptyTabContent/EmptyTabContent";

function EmptyPublicationsTab(props) {
  const { taskType, onButtonClick } = props;

  const renderText = () => {
    switch (taskType) {
      case "creator":
        return (
          <IDHFormattedMessage
            id="ws_empty_publications_tab_creator_text"
            defaultMessage="No publications has been assigned to this creator. \n Add new or assign already added publication."
          />
        );
      case "content":
        return (
          <IDHFormattedMessage
            id="ws_empty_publications_tab_publication_text"
            defaultMessage="No publications has been assigned to this content. \n Add new or assign already added publication."
          />
        );
    }
  };

  return (
    <EmptyTabContainer className="empty-publications-tab">
      <EmptyTabContent
        text={renderText()}
        buttonText={
          <IDHFormattedMessage
            id="ws_add_publication"
            defaultMessage="Add publication"
          />
        }
        onButtonClick={onButtonClick}
        buttonIcon={<PlusWhiteIcon />}
        imgUrl={NotFoundImg}
      />
    </EmptyTabContainer>
  );
}

export { EmptyPublicationsTab };
